export let videos_za_premium = [
    {
        id: 108,
        contents: 6,
        name: {
            en: "Humanity & Culture",
        },
        videos: [
            {
                duration: "Watch Now",
                id: 1080,
                name: "Ethiopia by Tuk Tuk",
                preview:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/Ethiopia+by+Tuk+Tuk.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1081,
                name: "Township ER",
                preview:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/Township+ER.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1082,
                name: "Beng Mealea An ancient temple reclaimed by nature",
                preview:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/Beng-Mealea-An-ancient-temple-reclaimed-by-nature.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/Beng+Mealea+An+ancient+temple+reclaimed+by+nature.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1083,
                name: "Inspire in a Minute From bullied bug hunter to kid author",
                preview:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/Inspire+in+a+Minute+From+bullied+bug+hunter+to+kid+author.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/Inspire+in+a+Minute+From+bullied+bug+hunter+to+kid+author.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1084,
                name: "Sights with Heights The cliff side sanctuary between heaven and earth",
                preview:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/Sights+with+Heights+The+cliff+side+sanctuary+between+heaven+and+earth.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/Sights+with+Heights+The+cliff+side+sanctuary+between+heaven+and+earth.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1085,
                name: "These countries should be really proud of their leaders right now",
                preview:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/These-countries-should-be-really-proud-of-their-leaders-right-now.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Humanity+%26+Culture/These+countries+should+be+really+proud+of+their+leaders+right+now.mp4",
                fileName: "",
            },
        ],
    },
    {
        id: 118,
        contents: 6,
        name: {
            en: "Music & Sport",
        },
        videos: [
            {
                duration: "Watch Now",
                id: 1180,
                name: "Burning Mountains",
                preview:
                    "https://cdn.mobiotv.com/premium/Music+%26+Sport/Burning+Mountains.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1181,
                name: "Streetkids United II",
                preview:
                    "https://cdn.mobiotv.com/premium/Music+%26+Sport/Streetkids+United+II.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1182,
                name: "Tiger Woods Biography",
                preview:
                    "https://cdn.mobiotv.com/premium/Music+%26+Sport/Tiger+Woods+Biography.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1183,
                name: "Sport for Change The initiative hitting it out of the park",
                preview:
                    "https://cdn.mobiotv.com/premium/Music+%26+Sport/Sport+for+Change+The+initiative+hitting+it+out+of+the+park.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Music+%26+Sport/Sport+for+Change+The+initiative+hitting+it+out+of+the+park.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1184,
                name: "The most talented player Pep Guardiola's ever seen",
                preview:
                    "https://cdn.mobiotv.com/premium/Music+%26+Sport/The+most+talented+player+Pep+Guardiola's+ever+seen.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Music+%26+Sport/The+most+talented+player+Pep+Guardiola's+ever+seen.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1185,
                name: "Young Football Fan Real Madrid couldn't ask for a better fan",
                preview:
                    "https://cdn.mobiotv.com/premium/Music+%26+Sport/Young+Football+Fan+Real+Madrid+couldn't+ask+for+a+better+fan.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Music+%26+Sport/Young+Football+Fan+Real+Madrid+couldn't+ask+for+a+better+fan.mp4",
                fileName: "",
            },
        ],
    },
    {
        id: 128,
        contents: 6,
        name: {
            en: "News & Politics",
        },
        videos: [
            {
                duration: "Watch Now",
                id: 1280,
                name: "A Question Of Humanity",
                preview:
                    "https://cdn.mobiotv.com/premium/News+%26+Politics/A+Question+Of+Humanity.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1281,
                name: "Apartheid",
                preview:
                    "https://cdn.mobiotv.com/premium/News+%26+Politics/Apartheid.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1282,
                name: "The Divided Soul Of America",
                preview:
                    "https://cdn.mobiotv.com/premium/News+%26+Politics/The+Divided+Soul+Of+America.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1283,
                name: "More than half of world’s forest wildlife disappeared",
                preview:
                    "https://cdn.mobiotv.com/premium/News+%26+Politics/More+than+half+of+world%E2%80%99s+forest+wildlife+disappeared.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/News+%26+Politics/More+than+half+of+world%E2%80%99s+forest+wildlife+disappeared.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1284,
                name: "Peace Builders The Art of Peaceful Resistance",
                preview:
                    "https://cdn.mobiotv.com/premium/News+%26+Politics/Peace+Builders+The+Art+of+Peaceful+Resistance.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/News+%26+Politics/Peace+Builders+The+Art+of+Peaceful+Resistance.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1285,
                name: "The “virginity test” still happens in these countries",
                preview:
                    "https://cdn.mobiotv.com/premium/News+%26+Politics/The+%E2%80%9Cvirginity+test%E2%80%9D+still+happens+in+these+countries.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/News+%26+Politics/The+%E2%80%9Cvirginity+test%E2%80%9D+still+happens+in+these+countries.mp4",
                fileName: "",
            },
        ],
    },
    {
        id: 138,
        contents: 6,
        name: {
            en: "Travel, Entertainment & Lifestyle",
        },
        videos: [
            {
                duration: "Watch Now",
                id: 1380,
                name: "Andy Warhol documentary",
                preview:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/Andy+Warhol+documentary.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1381,
                name: "OMO Child",
                preview:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/OMO+Child.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1382,
                name: "Fairy Tale Dream Spots The sinking castle of Scaligera",
                preview:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/Fairy+Tale+Dream+Spots+The+sinking+castle+of+Scaligera.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/Fairy+Tale+Dream+Spots+The+sinking+castle+of+Scaligera.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1383,
                name: "Medellín is the backpacking spot you've been looking for",
                preview:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/Medelli%CC%81n+is+the+backpacking+spot+you've+been+looking+for.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/Medelli%CC%81n+is+the+backpacking+spot+you've+been+looking+for.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1384,
                name: "Sights with Heights The narrow bridges of Caminito del Rey",
                preview:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/Sights+with+Heights+The+narrow+bridges+of+Caminito+del+Rey.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/Sights+with+Heights+The+narrow+bridges+of+Caminito+del+Rey.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1385,
                name: "This Dutch parade takes flower power to the next level",
                preview:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/This+Dutch+parade+takes+flower+power+to+the+next+level.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Travel%2C+Entertainment+%26+Lifestyle/This+Dutch+parade+takes+flower+power+to+the+next+level.mp4",
                fileName: "",
            },
        ],
    },
    {
        id: 148,
        contents: 6,
        name: {
            en: "Trending",
        },
        videos: [
            {
                duration: "Watch Now",
                id: 1480,
                name: "Jay-Z",
                preview: "https://cdn.mobiotv.com/premium/Trending/Jay-Z.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1481,
                name: "Madonna",
                preview: "https://cdn.mobiotv.com/premium/Trending/Madonna.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1482,
                name: "Michael Jackson",
                preview:
                    "https://cdn.mobiotv.com/premium/Trending/Michael+Jackson.png",
                desc: "",
                videoUrl: "",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1483,
                name: "The fascinating investigation findings after the Titanic sank",
                preview:
                    "https://cdn.mobiotv.com/premium/Trending/The-fascinating-investigation-findings-after-the-Titanic-sank.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Trending/The+fascinating+investigation+findings+after+the+Titanic+sank.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1484,
                name: "This 85-year-old grandma games harder than people half her age",
                preview:
                    "https://cdn.mobiotv.com/premium/Trending/This-85-year-old-grandma-games-harder-than-people-half-her-age.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Trending/This+85-year-old+grandma+games+harder+than+people+half+her+age.mp4",
                fileName: "",
            },
            {
                duration: "Watch Now",
                id: 1485,
                name: "With this e-bike, you can cycle on water",
                preview:
                    "https://cdn.mobiotv.com/premium/Trending/With-this-e-bike%2C-you-can-cycle-on-water.jpg",
                desc: "",
                videoUrl:
                    "https://cdn.mobiotv.com/premium/Trending/With+this+e-bike%2C+you+can+cycle+on+water.mp4",
                fileName: "",
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/constants/videos_za.js